var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"information_message_area"},[_c('div',{staticClass:"information_message"},[_c('a',{staticClass:"message_text",attrs:{"href":_vm.hrefUrl}},[_vm._v(_vm._s(_vm.strMsg))])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ce88ec6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/InformationMessage.vue
// module id = null
// module chunks = 